/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type {
  CartCheckoutRequestDto,
  CartCheckoutResponseDto,
  CustomerCheckoutRequestDto,
  CustomerCheckoutResponseDto,
  SubscriptionCheckoutRequestDto,
  SubscriptionCheckoutResponseDto,
} from ".././dtos";

import { apiRequest } from "../../api-request";
import type { ErrorType, BodyType } from "../../api-request";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const checkoutControllerGetCheckoutSession = (
  customerCheckoutRequestDto: BodyType<CustomerCheckoutRequestDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<CustomerCheckoutResponseDto>(
    {
      url: `/checkout/session`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: customerCheckoutRequestDto,
      signal,
    },
    options,
  );
};

export const getCheckoutControllerGetCheckoutSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkoutControllerGetCheckoutSession>>,
    TError,
    { data: BodyType<CustomerCheckoutRequestDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkoutControllerGetCheckoutSession>>,
  TError,
  { data: BodyType<CustomerCheckoutRequestDto> },
  TContext
> => {
  const mutationKey = ["checkoutControllerGetCheckoutSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkoutControllerGetCheckoutSession>>,
    { data: BodyType<CustomerCheckoutRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return checkoutControllerGetCheckoutSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckoutControllerGetCheckoutSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkoutControllerGetCheckoutSession>>
>;
export type CheckoutControllerGetCheckoutSessionMutationBody =
  BodyType<CustomerCheckoutRequestDto>;
export type CheckoutControllerGetCheckoutSessionMutationError =
  ErrorType<unknown>;

export const useCheckoutControllerGetCheckoutSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof checkoutControllerGetCheckoutSession>>,
      TError,
      { data: BodyType<CustomerCheckoutRequestDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof checkoutControllerGetCheckoutSession>>,
  TError,
  { data: BodyType<CustomerCheckoutRequestDto> },
  TContext
> => {
  const mutationOptions =
    getCheckoutControllerGetCheckoutSessionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const checkoutControllerCreateCartCheckoutSession = (
  cartCheckoutRequestDto: BodyType<CartCheckoutRequestDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<CartCheckoutResponseDto>(
    {
      url: `/checkout/cart-session`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cartCheckoutRequestDto,
      signal,
    },
    options,
  );
};

export const getCheckoutControllerCreateCartCheckoutSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkoutControllerCreateCartCheckoutSession>>,
    TError,
    { data: BodyType<CartCheckoutRequestDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkoutControllerCreateCartCheckoutSession>>,
  TError,
  { data: BodyType<CartCheckoutRequestDto> },
  TContext
> => {
  const mutationKey = ["checkoutControllerCreateCartCheckoutSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkoutControllerCreateCartCheckoutSession>>,
    { data: BodyType<CartCheckoutRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return checkoutControllerCreateCartCheckoutSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckoutControllerCreateCartCheckoutSessionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof checkoutControllerCreateCartCheckoutSession>>
  >;
export type CheckoutControllerCreateCartCheckoutSessionMutationBody =
  BodyType<CartCheckoutRequestDto>;
export type CheckoutControllerCreateCartCheckoutSessionMutationError =
  ErrorType<unknown>;

export const useCheckoutControllerCreateCartCheckoutSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof checkoutControllerCreateCartCheckoutSession>>,
      TError,
      { data: BodyType<CartCheckoutRequestDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof checkoutControllerCreateCartCheckoutSession>>,
  TError,
  { data: BodyType<CartCheckoutRequestDto> },
  TContext
> => {
  const mutationOptions =
    getCheckoutControllerCreateCartCheckoutSessionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const checkoutControllerGetSubscriptionCheckoutSession = (
  subscriptionIdentifier:
    | "CreatorMonthly"
    | "CreatorAnnual"
    | "LabelMonthly"
    | "LabelAnnual",
  subscriptionCheckoutRequestDto: BodyType<SubscriptionCheckoutRequestDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<SubscriptionCheckoutResponseDto>(
    {
      url: `/checkout/subscription-session/${subscriptionIdentifier}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: subscriptionCheckoutRequestDto,
      signal,
    },
    options,
  );
};

export const getCheckoutControllerGetSubscriptionCheckoutSessionMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof checkoutControllerGetSubscriptionCheckoutSession>
      >,
      TError,
      {
        subscriptionIdentifier:
          | "CreatorMonthly"
          | "CreatorAnnual"
          | "LabelMonthly"
          | "LabelAnnual";
        data: BodyType<SubscriptionCheckoutRequestDto>;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof checkoutControllerGetSubscriptionCheckoutSession>
    >,
    TError,
    {
      subscriptionIdentifier:
        | "CreatorMonthly"
        | "CreatorAnnual"
        | "LabelMonthly"
        | "LabelAnnual";
      data: BodyType<SubscriptionCheckoutRequestDto>;
    },
    TContext
  > => {
    const mutationKey = ["checkoutControllerGetSubscriptionCheckoutSession"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof checkoutControllerGetSubscriptionCheckoutSession>
      >,
      {
        subscriptionIdentifier:
          | "CreatorMonthly"
          | "CreatorAnnual"
          | "LabelMonthly"
          | "LabelAnnual";
        data: BodyType<SubscriptionCheckoutRequestDto>;
      }
    > = (props) => {
      const { subscriptionIdentifier, data } = props ?? {};

      return checkoutControllerGetSubscriptionCheckoutSession(
        subscriptionIdentifier,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CheckoutControllerGetSubscriptionCheckoutSessionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof checkoutControllerGetSubscriptionCheckoutSession>>
  >;
export type CheckoutControllerGetSubscriptionCheckoutSessionMutationBody =
  BodyType<SubscriptionCheckoutRequestDto>;
export type CheckoutControllerGetSubscriptionCheckoutSessionMutationError =
  ErrorType<unknown>;

export const useCheckoutControllerGetSubscriptionCheckoutSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof checkoutControllerGetSubscriptionCheckoutSession>
      >,
      TError,
      {
        subscriptionIdentifier:
          | "CreatorMonthly"
          | "CreatorAnnual"
          | "LabelMonthly"
          | "LabelAnnual";
        data: BodyType<SubscriptionCheckoutRequestDto>;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof checkoutControllerGetSubscriptionCheckoutSession>>,
  TError,
  {
    subscriptionIdentifier:
      | "CreatorMonthly"
      | "CreatorAnnual"
      | "LabelMonthly"
      | "LabelAnnual";
    data: BodyType<SubscriptionCheckoutRequestDto>;
  },
  TContext
> => {
  const mutationOptions =
    getCheckoutControllerGetSubscriptionCheckoutSessionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const checkoutControllerFulfillCheckoutSession = (
  sessionId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/checkout/fulfill/${sessionId}`, method: "POST", signal },
    options,
  );
};

export const getCheckoutControllerFulfillCheckoutSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkoutControllerFulfillCheckoutSession>>,
    TError,
    { sessionId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkoutControllerFulfillCheckoutSession>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const mutationKey = ["checkoutControllerFulfillCheckoutSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkoutControllerFulfillCheckoutSession>>,
    { sessionId: string }
  > = (props) => {
    const { sessionId } = props ?? {};

    return checkoutControllerFulfillCheckoutSession(sessionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckoutControllerFulfillCheckoutSessionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof checkoutControllerFulfillCheckoutSession>>
  >;

export type CheckoutControllerFulfillCheckoutSessionMutationError =
  ErrorType<unknown>;

export const useCheckoutControllerFulfillCheckoutSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof checkoutControllerFulfillCheckoutSession>>,
      TError,
      { sessionId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof checkoutControllerFulfillCheckoutSession>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const mutationOptions =
    getCheckoutControllerFulfillCheckoutSessionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
